var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgContactus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 669,
    viewBox: "0 0 1617 669",
    width: 1617,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m586 0h200v200h-200z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1318 128c55.22847 0 100 44.771525 100 100v100h-200v-100c0-55.228475 44.77153-100 100-100z",
    fill: "#fe5e33",
    transform: "matrix(1 0 0 -1 0 456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1118 0c55.22847 0 100 44.771525 100 100v100h-200v-100c0-55.228475 44.77153-100 100-100z",
    fill: "#fe5e33",
    transform: "matrix(-1 0 0 -1 2236 200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100 0c55.228475 0 100 44.771525 100 100v100h-100c-55.228475 0-100-44.771525-100-100s44.771525-100 100-100z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#11cdef",
    height: 200,
    rx: 100,
    width: 200,
    x: 683
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#172b4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m664 200h62v62c0 34.241654-27.758346 62-62 62s-62-27.758346-62-62 27.758346-62 62-62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1617 300h-200c0-55.228475 44.77153-100 100-100s100 44.771525 100 100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m981 224c0 55.228475-44.771525 100-100 100 0-55.228475 44.771525-100 100-100zm-200 200c0-55.228475 44.771525-100 100-100 0 55.228475-44.771525 100-100 100zm100-100c-55.228475 0-100-44.771525-100-100 55.228475 0 100 44.771525 100 100zm0 0c55.228475 0 100 44.771525 100 100-55.228475 0-100-44.771525-100-100z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1217 0h200v200h-200z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 0h200v200h-200z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 200h200v200h-200z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1022 200h100c55.22847 0 100 44.771525 100 100s-44.77153 100-100 100-100-44.771525-100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1373 496c-40.86907 0-74-33.354786-74-74.5s33.13093-74.5 74-74.5z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#11cdef",
    transform: "translate(17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1355 496v-149c41.42136 0 75 33.354786 75 74.5s-33.57864 74.5-75 74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565 200v-200c55.228475 0 100 44.771525 100 100s-44.771525 100-100 100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269 200v-200c55.228475 0 100 44.771525 100 100s-44.771525 100-100 100z",
    transform: "matrix(-1 0 0 -1 638 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 200,
    rx: 100,
    width: 200,
    y: 400
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400 300h200c0 55.228475-44.77153 100-100 100s-100-44.771525-100-100z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m200 200c0-55.228475 44.771525-100 100-100 0 55.228475-44.771525 100-100 100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m999 122c0 55.228475-44.771525 100-100 100 0-55.228475 44.771525-100 100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1030 417c55.22847 0 100 44.771525 100 100-55.22847 0-100-44.771525-100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1567 250c0 55.228475-44.77153 100-100 100 0-55.228475 44.77153-100 100-100z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199 400v-200c55.228475 0 100 44.771525 100 100s-44.771525 100-100 100z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 328c0-55.228475 44.771525-100 100-100 0 55.228475-44.771525 100-100 100z",
    fill: "#172b4d",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m817.000003 608.999998c-11.277899 14.945034-32.357139 25-56.5 25-24.142863 0-45.222102-10.054966-56.5-25 11.277898-14.945034 32.357137-25 56.5-25 24.142861 0 45.222101 10.054966 56.5 25z",
    fill: "#172b4d",
    transform: "matrix(.64278761 .76604444 -.76604444 .64278761 738.181088 -365.034456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.5 371c-24.808757-14.27203-41.5-40.947529-41.5-71.5s16.691243-57.22797 41.5-71.5c24.808757 14.27203 41.5 40.947529 41.5 71.5s-16.691243 57.22797-41.5 71.5zm-83 0c-24.808757-14.27203-41.5-40.947529-41.5-71.5s16.691243-57.22797 41.5-71.5c24.808757 14.27203 41.5 40.947529 41.5 71.5s-16.691243 57.22797-41.5 71.5z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fe5e33",
    height: 200,
    rx: 100,
    width: 200,
    x: 561,
    y: 346
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117 450c27.614237 0 50 22.385763 50 50s-22.385763 50-50 50c-27.6142375 0-50-22.385763-50-50s22.3857625-50 50-50z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.5 537c19.053824 0 34.5 15.446176 34.5 34.5s-15.446176 34.5-34.5 34.5-34.5-15.446176-34.5-34.5 15.446176-34.5 34.5-34.5z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1052 594c16.56854 0 30 13.431458 30 30s-13.43146 30-30 30-30-13.431458-30-30 13.43146-30 30-30z",
    fill: "#11cdef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m885 463c20.434536 0 37 16.565464 37 37s-16.565464 37-37 37-37-16.565464-37-37 16.565464-37 37-37z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.5 258c22.919817 0 41.5 18.356325 41.5 41s-18.580183 41-41.5 41-41.5-18.356325-41.5-41 18.580183-41 41.5-41z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417 50c27.614237 0 50 22.3857625 50 50 0 27.614237-22.385763 50-50 50s-50-22.385763-50-50c0-27.6142375 22.385763-50 50-50z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m783 50c27.614237 0 50 22.3857625 50 50 0 27.614237-22.385763 50-50 50s-50-22.385763-50-50c0-27.6142375 22.385763-50 50-50z",
    fill: "#fe5e33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1417 100c0 55.228475-44.77153 100-100 100 0-55.228475 44.77153-100 100-100zm-200 200c0-55.228475 44.77153-100 100-100 0 55.228475-44.77153 100-100 100zm100-100c-55.22847 0-100-44.771525-100-100 55.22847 0 100 44.771525 100 100zm0 0c55.22847 0 100 44.771525 100 100-55.22847 0-100-44.771525-100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1517 0h100v200h-100c-55.22847 0-100-44.771525-100-100s44.77153-100 100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1517 50c27.61424 0 50 22.3857625 50 50 0 27.614237-22.38576 50-50 50s-50-22.385763-50-50c0-27.6142375 22.38576-50 50-50z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514 395c0 55.228475-44.771525 100-100 100 0-55.228475 44.771525-100 100-100zm-200 200c0-55.228475 44.771525-100 100-100 0 55.228475-44.771525 100-100 100zm100-100c-55.228475 0-100-44.771525-100-100 55.228475 0 100 44.771525 100 100zm0 0c55.228475 0 100 44.771525 100 100-55.228475 0-100-44.771525-100-100z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m761 446c0 55.228475-44.771525 100-100 100 0-55.228475 44.771525-100 100-100zm-100 100c-55.228475 0-100-44.771525-100-100 55.228475 0 100 44.771525 100 100z",
    fill: "#172b4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgContactus3);
export default __webpack_public_path__ + "static/media/bg_contactus3.1d3265faa391a82f619bd30c2bcf5483.svg";
export { ForwardRef as ReactComponent };